import { Clock } from "lucide-react";

export default function PendingSyncBadge({ testId }) {
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-1 whitespace-nowrap">
      <Clock className="w-3 h-3" /> Pending sync
    </span>
  );
}
